<mat-grid-tile>
  <mat-card>
    <mat-card-title>
      <h4>Recycling Trend</h4>
    </mat-card-title>
    <mat-card-content>
      <app-trend></app-trend>
    </mat-card-content>
  </mat-card>
</mat-grid-tile>


<ul>
  @for (item of items | async; track item) {
    <li>
      <pre>{{ item | json }}</pre>
    </li>
  }
</ul>